import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';
import { useToast } from 'context/ToastContext';
import { copyToClipboard } from 'utils/helpers/copyToClipboard';
import SvgMapPin from 'components/svg/SvgMapPin';
import SvgClipCopy from 'components/svg/svgClipCopy';
import SolarIcon from 'components/icons/SolarIcon';

interface ClientShareLocationProps {
    client: any;
    locationUrl?: string;
    icon?: ReactNode;
}

const ClientShareLocation = ({
    client,
    locationUrl = '',
    icon = <SolarIcon name="share-fill" className="me-1" />,
}: ClientShareLocationProps) => {
    const { t } = useTranslation(['Clients']);
    const { showToast } = useToast();

    return (
        <Dropdown className="dd-share">
            <Dropdown.Toggle className="" disabled={!locationUrl} size="sm" variant="info" id="dropdown-basic">
                {icon}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item
                    target="_blank"
                    href={`viber://forward?text=${locationUrl}%0A%0A${client.clientName}%0A${client.clientPhone?.replace('+', '%2B')}`}
                >
                    <img className="img-social me-2" src="/imgs/social/viber.png" />Viber
                </Dropdown.Item>
                <Dropdown.Item
                    target="_blank"
                    href={`https://t.me/share/url?url=${locationUrl}%0A%0A${client.clientName}%0A${client.clientPhone?.replace('+', '%2B')}`}
                >
                    <img className="img-social me-2" src="/imgs/social/telegram.png" />Telegram
                </Dropdown.Item>
                <Dropdown.Item
                    target="_blank"
                    href={`https://wa.me/?text=${locationUrl}%0A%0A${client.clientName}%0A${client.clientPhone?.replace('+', '%2B')}`}
                >
                    <img className="img-social me-2" src="/imgs/social/whatsapp.png" />WhatsApp
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Item target="_blank" href={locationUrl}>
                    <SvgMapPin className="me-2" />
                    {t('popupOpenLocation')}
                </Dropdown.Item>

                <Dropdown.Item
                    onClick={() => {
                        copyToClipboard(`${locationUrl}\n\n${client.clientName}\n${client.clientPhone}`);
                        showToast(t('msssLocationCopied'), 'info');
                    }}
                >
                    <SvgClipCopy className="me-2" />
                    {t('popupCopyLocation')}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ClientShareLocation;
